import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: t('nav_home') },
    { to: '/category', label: t('nav_category') },
    { to: '/about', label: t('nav_about') },
  ];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="font-heading text-2xl font-bold text-primary-500 tracking-tight">
              j9
            </span>
            <span
              className={`hidden sm:inline text-sm font-medium transition-colors ${
                scrolled ? 'text-foreground-700' : 'text-background-50/90'
              }`}
            >
              {t('site_tagline')}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  isActive(link.to)
                    ? 'bg-primary-500 text-background-50'
                    : scrolled
                      ? 'text-foreground-700 hover:bg-background-100'
                      : 'text-background-50/90 hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="#"
              className="ml-2 px-5 py-2 rounded-lg text-sm font-semibold bg-accent-500 text-background-50 hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              j9注册
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled ? 'text-foreground-700' : 'text-background-50'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  isActive(link.to)
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="#"
              className="mt-2 px-4 py-3 rounded-lg text-sm font-semibold bg-accent-500 text-background-50 text-center cursor-pointer"
            >
              j9注册
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}